"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextSkeleton = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 600,
  margin: 'auto'
});
const TextSkeleton = exports.TextSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  width: '100%',
  height: 132,
  [theme.breakpoints.up('sm')]: {
    height: 88
  }
}));
